import React from 'react';
import { popularMentions, filterOptions } from '../data/mock';
import { ChevronDown, SlidersHorizontal } from 'lucide-react';

const ReviewFilters = ({ selectedFilter, onFilterChange }) => {
  return (
    <div className="mb-6">
      {/* Sort Dropdown */}
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
        <div className="flex items-center gap-2">
          <SlidersHorizontal className="w-4 h-4 text-gray-500" />
          <span className="text-sm text-gray-600">Plus de filtres</span>
        </div>
        
        <div className="relative">
          <select
            value={selectedFilter}
            onChange={(e) => onFilterChange(e.target.value)}
            className="appearance-none bg-white border rounded-lg px-4 py-2 pr-10 text-sm text-[#1a1a1a] cursor-pointer hover:border-gray-400 transition-colors focus:outline-none focus:ring-2 focus:ring-[#00b67a] focus:border-transparent"
          >
            {filterOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ChevronDown className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        </div>
      </div>

      {/* Popular Mentions */}
      <div>
        <p className="text-sm font-medium text-gray-600 mb-2">Mentions populaires</p>
        <div className="flex flex-wrap gap-2">
          {popularMentions.map((mention, index) => (
            <button
              key={index}
              className="px-3 py-1.5 text-sm bg-gray-100 text-gray-700 rounded-full hover:bg-gray-200 transition-colors"
            >
              {mention}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewFilters;
